<template>
  <div class="clearfix" v-if="!loader">
    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-if="loader" class="card mb-25 border-0 rounded-0 bg-white letter-spacing invisible" id="back">
    <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center" style="width: 30%;">
        <button
          class="default-outline-btn position-relative transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
          style="background-color: #EB9355;"
          @click="showScreen('excel')"
          data-bs-toggle="modal"
          data-bs-target="#filterLeadModal"
          id="excel"
        >
          {{ $t('export.excel') }}
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <button
          type="button"
          class="default-btn d-block text-center w-80 border-0 box-shadow fw-medium text-white rounded-1 pt-12 pb-12 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          data-bs-toggle="modal"
          data-bs-target="#generateLink"
        >
          {{ $t('export.paymentLink') }}
        </button>
      </div>
      <div class="d-sm-flex align-items-center">
        <div>
          <div class="select-calendar position-relative me-sm-10 ms-sm-15 mt-10 mt-sm-0">
            <input
              v-model="today"
              type="date"
              class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16"
              id="lead-calendar"
              :placeholder="leadPlaceholder"
              @change="searchTransaction1"
            />
          </div>
        </div>
        <button
          class="dot-btn lh-1 position-relative top-3 bg-transparent border-0 shadow-none p-0 transition d-inline-block mt-10 mt-sm-0"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#filterLeadModal"
          @click="showScreen('search')"
        >
          <i class="flaticon-dots"></i>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <div id="transactionsTable">
          <div>
            <span class="d-lg-inline-block p-2 text-start">
              <img src="../../assets/images/imoneyIcon1.png" alt="logo-icon" style="max-width:5%;"/>
              <span id="logo_text">IZYPAY</span>
            </span>
            <span id="headerLeftText" class="d-lg-inline-block p-2 text-start" style="margin-top: -2%;">support@imoney.africa</span>
            <p class="p-right">
              <span class="d-lg-block p-2 text-end redcolor" style="font-weight:1000;">{{ export_organisation_name }}</span>
              <span id="" class="d-block p-2 text-end redcolor" style="margin-top: -8%;">{{ export_email }}</span>
              <span id="" class="d-block p-2 text-end redcolor" style="margin-top: -8%;">{{ formatDateFr(new Date(export_start.date)) }}</span>
              <span class="d-block p-2 text-end redcolor" style="margin-top: -8%;">{{ $t('export.transferBalance') }} : {{ export_start.payout_balance }} XOF</span>
              <span class="d-block p-2 text-end redcolor" style="margin-top: -8%;">{{ $t('export.collectBalance') }} : {{ export_start.collect_balance }} XOF</span>
              <span id="" class="d-block p-2 text-end redcolor" style="margin-top: -8%;">{{ formatDateFr(new Date(export_end.date)) }}</span>
              <span class="d-block p-2 text-end redcolor" style="margin-top: -8%;">{{ $t('export.transferBalance') }} : {{ export_end.payout_balance }} XOF</span>
              <span class="d-block p-2 text-end redcolor" style="margin-top: -8%;">{{ $t('export.collectBalance') }} : {{ export_end.collect_balance }} XOF</span>
            </p>
          </div>
          <hr />
          <div style="margin-top: 7%;">
            <h2 class="shadow-none lh-1 fw-medium" id="title" style="">
              <span id="title1">{{ $t('export.operationsStatement') }}</span>
              <span class="text-end" id="title2">{{ $t('export.period') }} <span class="date">{{ formatDateFr(new Date(beginDate)) }}</span> {{ $t('export.to') }} <span class="date">{{ formatDateFr(new Date(endDate)) }}</span></span>
            </h2>
          </div>
          <hr />
          <div style="padding-left: 1%;padding-right: 1%;" class="">
            <table id="tableLayout" class="table" style="margin-right: 1%;">
              <thead id="t-thead-pdf" style="">
                <tr>
                  <th scope="col" style="" class="tableHeader">
                    {{ $t('export.transactionCode') }}
                  </th>
                  <th class="tableHeader">
                    {{ $t('export.operation') }}
                  </th>
                  <th class="tableHeader">
                    {{ $t('export.fees') }}
                  </th>
                  <th scope="col" class="tableHeader">
                    {{ $t('export.amount') }}
                  </th>
                  <th scope="col" class="tableHeader">
                    {{ $t('export.date') }}
                  </th>
                  <th scope="col" class="tableHeader1" style="border-top-left-radius: 1px;border-bottom-left-radius: 1px;">
                    {{ $t('export.status') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(transaction1) in transaction1s" :key="transaction1.transaction_number">
                  <td class="fw-medium">
                    {{ transaction1.transaction_number }}
                  </td>
                  <td class="shadow-none lh-1 fw-medium">
                    {{ transaction1.operation }}
                  </td>
                  <td class="fw-medium">
                    <span>{{ transaction1.fees.toLocaleString() }}</span>
                  </td>
                  <td class="shadow-none lh-1 fw-medium">
                    <span>{{ transaction1.amount.toLocaleString() }}</span>
                  </td>
                  <td class="shadow-none lh-1 fw-medium">
                    {{ formatDateFr(new Date(transaction1.date)) }}
                  </td>
                  <td class="shadow-none lh-1 fw-medium">
                    <span v-if="transaction1.status==='FAILED'">{{ $t('export.failed') }} <img src="../../assets/images/echec.svg" alt="logo-icon" style="max-width:25%;"/></span>
                    <span v-if="transaction1.status==='SUCCEEDED'">{{ $t('export.success') }} <img src="../../assets/images/success.svg" alt="logo-icon" style="max-width:25%;"/></span>
                    <span v-if="transaction1.status==='PROCESSING'">{{ $t('export.processing') }} <img src="../../assets/images/pending.svg" alt="logo-icon" style="max-width:25%;"/></span>
                    <span v-if="transaction1.status==='PENDING'">{{ $t('export.pending') }} <img src="../../assets/images/pending.svg" alt="logo-icon" style="max-width:25%;"/></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Export -->
  <div class="modal fade" id="filterLeadModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 v-if="screenSelected=='excel'" class="modal-title fs-5">{{ $t('export.exportFinancialData') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <div v-if="errors!==''" style="margin-top: 5%;">
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">code: {{ errorId }}</h6>
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors }}</h6>
          </div>
          <div class="form-group mb-15 mb-sm-20 mb-md-25">
            <div class="row">
              <div class="col-md-10" v-if="current_permissions('SUPERADMIN')">
                <label class="d-block text-black fw-semibold mb-10">{{ $t('export.clients') }}</label>
                <select name="organization" id="organization" class="form-select fs-md-15 text-black shadow-none" @change="handleOrganizationChange" required>
                  <option value="">{{ $t('export.select') }}</option>
                  <option v-for="organization in organizations" :value="organization.code" :key="organization.id"> {{ organization.name }}</option>
                </select>
              </div>
              <div class="col-md-2">
                <div class="form-check" style="margin-top:40%;">
                  <input class="form-check-input" type="checkbox" value="1" id="invalidCheck" />
                  <label>{{ $t('export.detail') }}</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="d-block text-black fw-semibold mb-10">{{ $t('export.startDate') }}</label>
                <div>
                  <input v-model="beginDate" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="leadPlaceholder" />
                </div>
              </div>
              <div class="col-md-6">
                <label class="d-block text-black fw-semibold mb-10">{{ $t('export.endDate') }}</label>
                <div>
                  <input v-model="endDate" type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" id="lead-calendar" :placeholder="leadPlaceholder" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer" v-if="current_permissions('global_report')">
          <button v-if="screenSelected=='excel'" :disabled="!btnLoad" type="button" class="btn" style="background-color: #EB9355;" @click="searchTransactionForExport()">
            <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
            <span style="color: #FFF;">{{ $t('export.exportBtn') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div id="snackbar"></div>
</template>

<script setup  lang="ts">
import {ref, onMounted,onBeforeMount,inject  } from "vue";
import axios from 'axios';
import flatpickr from "flatpickr";
import html2pdf from "html2pdf.js";
import router from '../../router/index'
import { useI18n } from "vue-i18n";
import {current_permissions} from '../../utils/permission';
import { showToast,validate_phone_number,checkSessionValidate } from "@/utils/function";
// import {SERVER} from "../../../utils/const"
// import {export_json_to_excel} "../../../utils/Export2Excel";
const backApi=inject('back');

declare interface Transaction {
    id: number,
    checkoutId: string,
    operator: string,
    contact: string,
    amount: string,    
    transactionDate: string,
    paymentStatus: string
  }

  declare interface Organization {
  id : string,
  code: string,
  name: string,
  description: string,    
  email: string,
  created_at: string
  }

  declare interface Operator {
  id : string,
  code: string,
  mnoName: string,
  status: string,    
  countryCode: string  
  }

const leadPlaceholder = "Select date";

let data = [];
let transaction1s = ref([]);
let beginDate = ref('');
let endDate = ref('');
let today = ref('');
const selectedOrganization = ref('');
const selectedOperator = ref('');
const selectedStatus = ref('');
const loader = ref(false);
const page = ref(1);
const total = ref(0);
let link = ref('');
let amount = ref(0);
//const pageServ = ref('');
const pagesLeft = ref(0);
const { locale, t } = useI18n();
const currentPage = ref(0);
const numPages = ref(0);
const gettran = ref(false);
const search = ref(false);
const search1 = ref(false);
const operator = ref('');
const paymentStatus = ref(''); 
const screenSelected = ref(''); 
const btnLoad = ref(true);
const errors = ref('');
const errorId = ref('');
let result = ref(0);    
const transactions =ref(new Array<Transaction>());
const organizations =ref(new Array<Organization>());
const operators =ref(new Array<Operator>());
let operatorsTemp =new Array<Operator>();
const transaction =ref({} as Transaction);
const organization_name =  localStorage.getItem('organization_name');
const email =  localStorage.getItem('email');

let export_organisation_name = ref('');
let export_email = ref('');
let export_start = ref('');
let export_end = ref('');
  function formatDateFr(value){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate();  
        day = day<10?'0'+day:day;      
        return day+'/'+month+'/'+year;
        
    }
}

function formatDateEn(value,d=0){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate()+d;  
        day = day<10?'0'+day:day;      
        return year+'-'+month+'-'+day;
        
    }
}

function formatDateEnBis(value,d=0){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate()+d;  
        day = day<10?'0'+day:day;      
        return year+'-'+month+'-'+day;
        
    }
}


function closeModal() {
      router.go(-1);
}
function handleOrganizationChange(event) {
      selectedOrganization.value = event.target.value;
    }

function handleOperatorChange(event) {
  selectedOperator.value = event.target.value;
}

function handleStatusChange(event) {
  selectedStatus.value = event.target.value;
}

function handleCountryChange(event) {
  // // selectedStatus.value = event.target.value;
  // operators
  var j = 0;
  var operatorArr = new Array<Operator>();
  while(j<operatorsTemp.length){    
      if(operatorsTemp[j].countryCode == event.target.value){         
          operatorArr.push(operatorsTemp[j]);
      }      
      j++;
  }
   operators.value = operatorArr;
}

function reset(){
  amount.value = 0;
  link.value = '';
  result.value=0;
}

function copyToCliboard() {
  // Get the text field
  var copyText = document.getElementById("link");
  // Select the text field
  copyText.select();
  copyText.setSelectionRange(0, 99999); // For mobile devices
   // Copy the text inside the text field
  navigator.clipboard.writeText(copyText.value);
  showToast("Copié","green");
}

const generateLink = ()=>{

try {  
  
  axios.post(`${backApi}/secure/transactions/token`,{          
          amount:amount.value,          
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }       
      }).then((response) => {  
        if(response.status === 201){  
          // alert(response.data.ticketUrl); 
          link.value =  response.data.ticketUrl
          result.value=1;
        }      
        
    }).catch((error) => {
      // alert(error.response.data.errorId);
          if( error.response){
              //console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;
              } 
              
          }
  });
} catch (error) {
        // console.log(error);        
         errors.value="une erreur inattendue est apparue"
         
              
}

}
    


onMounted(() => {
  checkSessionValidate(1)
  // getTransactions();
  getOrganizations();
  // getOperators();
  
  setTimeout(function () {
    //loader.value=true; 
        flatpickr("#lead-calendar", {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        defaultDate: "today",
        enableTime: true,
      });
        },1000);

        loader.value=true;
});

setTimeout(function () {
  const excel = document.getElementById("excel");
  excel?.click()
},1000);

const token =  localStorage.getItem('login_token');
const loadTransaction = (code)=>{
  
  axios.get(`${backApi}/secure/transactions/${code}`,{//SERVER+ //https://test.zivwallet.com/api/countries//dateD=${today}&
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        // users.value = response.data;
        transaction.value = response.data;  //.data.users   
        // data  = response.data.transactions;  
        operator.value=  response.data.operator.mnoName;
        amount.value= response.data.amount.toLocaleString();
       
         if(response.data.paymentStatus==='SUCCEEDED'){
          paymentStatus.value = "SUCCESS"
         }else if(response.data.paymentStatus==='PROCESSING'){
          paymentStatus.value = "EN COURS"
         }else{
          paymentStatus.value = "ECHEC"
         }   
         
        loader.value=true;
        
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                //window.location.href = data1.proxy+'/';
                //window.location.href = '/';
                router.push('/');
              }   
              
          }
  });
}
const getTransactions = (arg=1) =>{
    loader.value=false;
    gettran.value = true;
    search.value = false;
    search1.value = false;
    
    const todayB =  formatDateEn(new Date()); //'2024/01/01'
    const todayE =  formatDateEn(new Date(),1);   
    //conf.proxy
    axios.get(`${backApi}/secure/transactions?page=${arg}&dateD=${todayB}&dateF=${todayE}&operationType=${process.env.VUE_APP_PAYIN_OPTTYPE}`,{//SERVER+ //https://test.zivwallet.com/api/countries//dateD=${today}&
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        // users.value = response.data;
        transactions.value = response.data.transactions;  //.data.users   
        // data  = response.data.transactions;  
        total.value=parseInt(response.data.pagination.total);
        page.value=parseInt(response.data.pagination.page);
        pagesLeft.value=parseInt(response.data.pagination.pagesLeft);
        currentPage.value=parseInt(response.data.pagination.currentPage);
        numPages.value=parseInt(response.data.pagination.numPages);
        
        // for (let pas = 0; pas < data.length; pas++) {
        //   data[pas].operator_name = data[pas].operator.mnoName;
        // }    
         //console.log(pagination.value);
        loader.value=true;
        
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                //window.location.href = data1.proxy+'/';
                //window.location.href = '/';
                router.push('/');
              }   
              
          }
  });

}
const getOrganizations = () =>{

    axios.get(backApi+'/secure/organizations/',{  
      headers: {
           
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {
        // users.value = response.data;
        organizations.value = response.data;  //.data.users          
        console.log(response.data);
        
        
    }).catch((error) => {
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                //window.location.href = '/';
                //router.push('/');
              }   
              
          }
   });
  //  loader.value=true;
}
const getOperators = () =>{

axios.get(backApi+'/public/operators/',{  //secure
  headers: {
       
        Authorization: `Bearer ${token}`
  } 
})
.then((response) => {
    // users.value = response.data;
    operatorsTemp = response.data;  //.data.users          
    console.log(response.data);
    
    
}).catch((error) => {
      if( error.response){
          console.log(error.response.data); // => the response payload 
          if(error.response.status === 401){
            router.push('/')
            
          }   
          
      }
});
//  loader.value=true;
}

const exportExcelReport = (labels,fields,filename) =>{
  
  import("../../utils/Export2Excel").then((excel)=>{
 
    const dataForExcel= formatJSon(fields,data);
    // console.log(dataForExcel);
    excel.export_json_to_excel({     
      header:labels,
      data:dataForExcel,
      sheetName:"Feuil1",
      filename:filename,      
      autoWidth: true,
      bookType:"xlsx",
  });
  });
}

const exportExcelReportOld = () =>{
  
  import("../../utils/Export2Excel").then((excel)=>{
    // const data = transactions.value;
    const Header =["CODE TRANSACTION","DATE OPERATION","OPERATEUR","MONTANT","TYPE OPERATION","BALANCE","STATUT"];
    const Fields = ["checkoutId","transactionDate","status","amount","operationType","","paymentStatus"];//"operator_name",
    // console.log(data);
    const dataForExcel= formatJSon(Fields,data);
    // console.log(dataForExcel);
    excel.export_json_to_excel({     
      header:Header,
      data:dataForExcel,
      sheetName:"Feuil1",
      filename:"report",      
      autoWidth: true,
      bookType:"xlsx",
  });
  });
}

const exportExcel = () =>{
  
  import("../../utils/Export2Excel").then((excel)=>{
    // const data = transactions.value;
    const Header =["CODE TRANSACTION","OPERATEUR","TELEPHONE","MONTANT","DATE","STATUT"];
    const Fields = ["checkoutId","operator_name","contact","amount","transactionDate","paymentStatus"];//mnoName
    // console.log(data);
    const dataForExcel= formatJSon(Fields,data);
    // console.log(dataForExcel);
    excel.export_json_to_excel({     
      header:Header,
      data:dataForExcel,
      sheetName:"Feuil1",
      filename:"transactions",      
      autoWidth: true,
      bookType:"xlsx",
  });
  });
}


function formatJSon(FilterData,JsonData){
  return JsonData.map((v)=>FilterData.map(j=>{
      return v[j];
    }));
}


//[top, left, bottom, right]
const searchTransaction = (arg=1)=>{
  loader.value=false;
  gettran.value = false;
  search.value = true;
  search1.value = false;
  
  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date()); 
  }
   
  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1); 
  }
    const todayE =  formatDateEn(new Date(endDate.value),1);   
  axios.get(`${backApi}/secure/transactions?page=${arg}&dateD=${beginDate.value}&dateF=${todayE}&organization=${selectedOrganization.value}&operator=${selectedOperator.value}&paymentStatus=${selectedStatus.value}&operationType=${process.env.VUE_APP_PAYIN_OPTTYPE}`,{//SERVER+ //https://test.zivwallet.com/api/countries
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        // users.value = response.data;
        transactions.value = response.data.transactions;  //.data.users   
        // data  = response.data.transactions;  
        total.value=parseInt(response.data.pagination.total);
        page.value=parseInt(response.data.pagination.page);
        pagesLeft.value=parseInt(response.data.pagination.pagesLeft);
        currentPage.value=parseInt(response.data.pagination.currentPage);
        numPages.value=parseInt(response.data.pagination.numPages);
        // for (let pas = 0; pas < data.length; pas++) {
        //   data[pas].operator_name = data[pas].operator.mnoName;
        // }    
        //  console.log(data);
        loader.value=true; 
        
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                //window.location.href = data1.proxy+'/';
                //window.location.href = '/';
                router.push('/');
              }   
              
          }
  });
}
const searchTransaction1 = (event,arg=1)=>{ 
  // alert(typeof event ) 
  // alert(event.target.value)
  // alert(arg)  
   if(typeof event.target.value!=='undefined'){
    today.value = event.target.value 
   }  
  
    // alert(today.value)  
    loader.value=false;
    gettran.value = false;
    search.value = false;
    search1.value = true;

    const todayE =  formatDateEn(new Date(today.value),1);   
  axios.get(`${backApi}/secure/transactions?page=${arg}&dateD=${today.value}&dateF=${todayE}&operationType=${process.env.VUE_APP_PAYIN_OPTTYPE}`,{//SERVER+ //https://test.zivwallet.com/api/countries
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        // users.value = response.data;
        transactions.value = response.data.transactions;  //.data.users   
        // data  = response.data.transactions;  
        total.value=parseInt(response.data.pagination.total);
        page.value=parseInt(response.data.pagination.page);
        pagesLeft.value=parseInt(response.data.pagination.pagesLeft);
        currentPage.value=parseInt(response.data.pagination.currentPage);
        numPages.value=parseInt(response.data.pagination.numPages);
        // for (let pas = 0; pas < data.length; pas++) {
        //   data[pas].operator_name = data[pas].operator.mnoName;
        // }    
        //  console.log(data);
        loader.value=true; 
        
    }).catch((error) => {
      loader.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                //window.location.href = data1.proxy+'/';
                //window.location.href = '/';
                router.push('/');
              }   
              
          }
  });
}

const searchTransactionForExport = ()=>{  
   btnLoad.value=false;
  
  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date()); 
  }
   
  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1); 
  }

  let check = document.getElementById("invalidCheck").checked;
  let option= '';
  // alert(check);
  // let custom = 0;
  const todayE =  formatDateEn(new Date(endDate.value),1);
  let endpointEnd = (selectedOrganization.value==='')?'global':'organization' 
  if(endpointEnd=='global'){
    endpointEnd = (check)?endpointEnd+'/custom':endpointEnd
  }
  
  let body={
    start: beginDate.value,
    end: todayE,
    organization: (selectedOrganization.value==='')?null:selectedOrganization.value
  }

     
  axios.post(`${backApi}/secure/report/${endpointEnd}`,
    body,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        // users.value = response.data;
        // transactions.value = response.data.transactions;  //.data.users 
        data = [];
        if(response.status === 200){  
         
        if(option=='excel'){
        let Header =[];
        let Fields =[];
        if(endpointEnd=='organization'){
          data  = response.data.transactions; 
          for (let pas = 0; pas < data.length; pas++) {
          data[pas].operator_name = data[pas].operator.mnoName;
          let operationType = data[pas].operationType;
          data[pas].operationType = (operationType=="1")?"Payin":"Payout";
          data[pas].checkoutId = (operationType=="1")?data[pas].checkoutId:data[pas].payoutId;          
          // data[pas].balance = parseFloat(data[pas].collectBalance-(data[pas].payoutBalance-data[pas].topupBalance));//repayment_balance 

          }  
        
          Header =["CODE TRANSACTION","DATE OPERATION","OPERATEUR","MONTANT","TYPE OPERATION","SOLDE DE COLLECTE","SOLDE DE TRANSFERT","STATUT"];
          Fields = ["checkoutId","transactionDate","operator_name","amount","operationType","collectBalance", "payoutBalance","paymentStatus"];
        }else{
            if(!check){
              let temp  = response.data;  
              let tempJson = {
                start:temp.start,
                collectBalance:temp.startData.collectBalance,
                availableBalance:temp.startData.availableBalance,
                payoutBalance:temp.startData.payoutBalance,
                end:temp.end,
                collectBalanceEnd:temp.endData.collectBalance,
                availableBalanceEnd:temp.endData.availableBalance,
                payoutBalanceEnd:temp.endData.payoutBalance,
              } 
              data.push(tempJson);
              Header =["DEBUT PERIODE","SOLDE DE COLLECTE","SOLDE DISPONIBLE","SOLDE DE TRANSFERT","FIN PERIODE","SOLDE DE COLLECTE","SOLDE DISPONIBLE","SOLDE DE TRANSFERT"];
              Fields = ["start","collectBalance","availableBalance","payoutBalance","end","collectBalanceEnd","availableBalanceEnd","payoutBalanceEnd"];
            }else{
              let temp  = response.data;  
              // let i = 0;
              for (let i = 0; i < temp.reports.length; i++) {
                let tempJson = {
                  organization:temp.reports[i].organization.name,
                  start:temp.start,
                  collectBalance:temp.reports[i].startData.collectBalance,
                  availableBalance:temp.reports[i].startData.availableBalance,
                  payoutBalance:temp.reports[i].startData.payoutBalance,
                  end:temp.end,
                  collectBalanceEnd:temp.reports[i].endData.collectBalance,
                  availableBalanceEnd:temp.reports[i].endData.availableBalance,
                  payoutBalanceEnd:temp.reports[i].endData.payoutBalance,
                } 
                // console.log(tempJson);
                data.push(tempJson);
              }
              Header =["ORGANISATION","DEBUT PERIODE","SOLDE DE COLLECTE","SOLDE DISPONIBLE","SOLDE DE TRANSFERT","FIN PERIODE","SOLDE DE COLLECTE","SOLDE DISPONIBLE","SOLDE DE TRANSFERT"];
              Fields = ["organization","start","collectBalance","availableBalance","payoutBalance","end","collectBalanceEnd","availableBalanceEnd","payoutBalanceEnd"];
            }
        }
        exportExcelReport(Header,Fields,"report");  
        }else{
             
              export_organisation_name.value=response.data.organization.name
              export_email.value=response.data.organization.email
              // export_balance_transfert.value=response.data.end.payout_balance
              // export_balance_collecte.value=response.data.end.collect_balance

              export_start.value=response.data.start
              export_end.value=response.data.end
              transaction1s.value=response.data.operations;
              // alert(response.data.organization.name)
              exportToPDF()  
        }


        btnLoad.value=true; 
      }   
    }).catch((error) => {
      btnLoad.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                //window.location.href = data1.proxy+'/';
                //window.location.href = '/';
                router.push('/');
              } else{                
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;               
         
              }  
              
          }
  });
}

const reportForExport = ()=>{  
   btnLoad.value=false;
  
  if(beginDate.value===''){
    beginDate.value =  formatDateEn(new Date()); 
  }
   
  if(endDate.value===''){
    endDate.value =  formatDateEn(new Date(),1); 
  }
  // alert(selectedOrganization.value);
    const todayE =  formatDateEn(new Date(endDate.value),1);   
  axios.post(`${backApi}/secure/organizations/report`,
       {          
         start:beginDate.value,
         end:todayE,
          organization:selectedOrganization.value          
        },
        {
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {        
        if(response.status === 200){  
        data  = response.data.transactions;  
        // const dataTemp  = response.data; 
        console.log(data)
        
        for (let pas = 0; pas < data.length; pas++) {
          // data[pas].operator_name = data[pas].operator.mnoName;
          data[pas].operationType = (data[pas].operationType=="1")?"Payin":"Payout";
          data[pas].balance = parseFloat(data[pas].collectBalance-(data[pas].payoutBalance-data[pas].topupBalance));        
        }  
        
        const Header =["CODE TRANSACTION","DATE OPERATION","OPERATEUR","MONTANT","TYPE OPERATION","BALANCE","STATUT"];
        const Fields = ["checkoutId","transactionDate","status","amount","operationType","","paymentStatus"];

        exportExcelReport(Header,Fields,"report"); 
        //  console.log(data);
        btnLoad.value=true; 
      }   
    }).catch((error) => {
      btnLoad.value=true;
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                //window.location.href = data1.proxy+'/';
                //window.location.href = '/';
                router.push('/');
              } else{                
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;               
         
              }  
              
          }
  });
}

const showScreen = (screen)=>{ 
  screenSelected.value=screen
}


const exportToPDF = () =>{   
  
  setTimeout(() => {  

        document.getElementById("transactionsTable").style.display='block';
        const opt ={margin: [0, 0, 0, 0],filename: "transactions.pdf",jsPDF:{ unit: 'mm', format: 'a4', orientation: 'portrait',putOnlyUsedFonts:true,floatPrecision: "smart"  },image:        { type: 'jpeg', quality: 0.98 },
        html2canvas:  { scale: 2 },}
        // const opt ={margin: [0, 0, 0, 0],filename: "transactions.pdf",jsPDF:{ unit: 'mm', format: 'a4', orientation: 'portrait',putOnlyUsedFonts:true,floatPrecision: "smart"  }}
        //landscape//portrait/format: 'letter'/unit: 'in',/unit: 'mm',/unit: 'cm',
      
      html2pdf().set(opt).from(document.getElementById("transactionsTable")).toPdf().get('pdf').then(function (pdf) {
      
      window.open(pdf.output('bloburl'), '_blank');
      document.getElementById("transactionsTable").style.display='none';
      });

    }, 3000);
    
 
}

</script>
<style scoped>
 #title{
 text-decoration: underline;
 border-bottom: 1px solid #861727;
}
#subtitle{
 margin-bottom: 5%;
}
#headerRightText{
 padding-right: 2%;
 width:50%;
float:right;
font-weight: bold;
}
.headerRight{
 padding-right: 2%;
 width:50%;
float:right;
font-weight: bold;
}
#headerLeftText{
 padding-right: 2%;
 width:50%;
float:left;
font-weight: bold;
}
.p-right{
  float:right;
  margin-top: -7%;
}
#transactionsTable{
 display: none; 
 margin-right:5%;
 margin-left:5%;
 /* visibility: hidden; */
}
td, th {
  height:15px !important;  
}

.tableHeader{
  height: 10px;
  font-size: 15px;
  padding-top:-2px ;
  font-weight: bold;
  background-color: #EC9B59;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
  color: #fff;
}
.tableHeader1{
  height: 10px;
  font-size: 15px;
  /* padding: auto; */
  font-weight: bold;
  background-color: #EC9B59;
  border-right: 1px solid #EC9B59;
  border-top-right-radius: 90px;
  border-bottom: 1px solid #fff;
  color: #fff;

}
hr {
  border-top: 2px solid #fff;
  width:100%;
  margin-top: 5%;
}
#tableLayout{
  /* border: 1px solid black; */
}

#tableLayout td,#tableLayout th{
  /* border: 1px solid black; */
   font-size: 10px;
}

#tableLayout td{
  /* border: 1px solid black; */
  border-bottom: 0.05px solid #861727;
  
}
#sub_business1,#container_sub_business{
  display: none; 
}
.redcolor{
  color: #861727;
}

#title1{
  display: inline-block;
  background-color: #861727;
  color: #fff;
  font-size: 50%;
  border: 1px solid #861727;
  border-radius: 5px 5px 5px 0px;
  padding: 5px 10px 5px 10px;
}
#title2{
font-size: 50%;
/* float:right; */
/* margin-bottom: -10%; */
display: inline-block;
/* margin-right: -10%; */
margin-left: 35%;
}
.date{
font-weight: bold;
}
/* #t-thead-pdf{
  background-color: #EC9B59;
  border:  1px solid #EC9B59;
} */
/* rule for A5 */
#receipt{
  margin-top: 5px;
  /* display: none;   */
}
#header_receipt{
  margin-top: -1%;
  background-color: #871728;
}
#header_text{
  font-size: 70%;
  float: inline-end;
  margin-top: 3%;
  /* margin-left: 10%; */
}
#arrow-top-section{
  /* display: flex; */
  /* flex-direction: row; */
}
#arrow-top-left{
  /* float: inline-start; */
  margin-left:7%
}
#arrow-top-right{
  /* float: inline-end; */
  margin-left:80%
}
#arrow-bottom-left{
  /* float: inline-start; */
  margin-left:7%
}
#arrow-bottom-right{
  /* float: inline-end; */
  margin-left:80%
}

#body_receipt{
  display: flex;
  flex-direction: column;
  padding-top: 15%;
  padding-bottom: 15%;
}
#body_first_section{
  margin-left: 10%;
  margin-right: 10%;
  border: 1px solid #706F6F ;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}
#body_second_section{
  margin-top:5%;
  margin-left: 10%;
  margin-right: 10%;
  border: 1px solid #706F6F ;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}
#body_third_section{
  margin-top:5%;
  margin-left: 10%;
  margin-right: 10%;
  border: 1px solid #706F6F ;
  border-radius: 10px;
  padding: 5px 15px 5px 15px;
}
.section_label{
  font-size: 100%;
  font-weight: bold;
}
.section_content_other{
  display: inline-block;
  color: #fff;
  background-color: #EB9355;
  border: 1px solid #EC9B59;
  border-radius: 10px;
  margin-left: 7%;
  padding: 5px 15px 5px 15px;
}
.section_content_other1{
  display: inline-block;
  color: #fff;
  background-color: #EB9355;
  border: 1px solid #EC9B59;
  border-radius: 10px;
  /* margin-left: 10%; */
  padding: 5px 15px 5px 15px;
}
#logo_text{
  font-family: gruppo;
  font-weight:bold;
  font-size: 25px;
} 

thead tr:first-child th:first-child {
    /* border: 2px solid green; */
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;
    height: 10px;
}
    
thead tr:first-child th:last-child {
    /* border: 2px solid green; */
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
    height: 10px;
}
/* end rule for A5 */
</style>